import React, { ComponentProps } from 'react'
import CarouselLockedCardLoadingSkeleton from './CarouselLockedCardLoadingSkeleton'
import OfferCardMapper from './OfferCardMapper'
import CarouselCardLoadingSkeleton from './CarouselCardLoadingSkeleton'

type InheritedOfferCardProps = Pick<ComponentProps<typeof OfferCardMapper>, 'variant' | 'size'>

interface Props extends InheritedOfferCardProps, React.HTMLAttributes<HTMLDivElement> {
}

function OfferCardLoadingSkeleton({ variant = 'card-default', size = 'small', ...rest }: Props) {
  if (variant === 'card-default' || variant === 'card-opaque') {
    return <CarouselCardLoadingSkeleton {...rest} size={size} variant={variant === 'card-opaque' ? 'opaque' : 'default'} />
  }

  if (variant === 'card-locked') {
    return <CarouselLockedCardLoadingSkeleton {...rest} size={size} />
  }
}

export default OfferCardLoadingSkeleton
